if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // Collecter les champs hors du <form> mais dans <product-form>
      // (ex: quantity-input qui utilise form="..." ou champs personnalisation)
      const externalElements = this.querySelectorAll('input, textarea, select');
      console.log('[ProductForm] Total éléments trouvés:', externalElements.length);
      
      externalElements.forEach((el) => {
        console.log('[ProductForm] Élément:', el.name, el.type, el.value, 'has?', formData.has(el.name));
        if (!el.name || formData.has(el.name)) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        formData.append(el.name, el.value);
        console.log('[ProductForm] ✓ Ajouté:', el.name, '=', el.value);
      });

      // Si pas de quantity trouvée, ajouter quantity=1 par défaut
      if (!formData.has('quantity')) {
        formData.append('quantity', '1');
        console.log('[ProductForm] ✓ Ajouté quantity par défaut: 1');
      }

      // Debug
      console.log('[ProductForm] Champs envoyés:');
      for (const [k, v] of formData.entries()) console.log('  ' + k + ':', v);
      
      // Vérifier si authenticity_token est présent
      if (!formData.has('authenticity_token')) {
        console.warn('[ProductForm] ⚠️ CSRF token manquant! Le formulaire doit être généré avec {% form "product" %}');
        
        // Debug: chercher le token dans le DOM
        const tokenInput = this.form.querySelector('input[name="authenticity_token"]');
        console.log('[ProductForm] Token input trouvé?', tokenInput ? 'OUI' : 'NON');
        
        if (tokenInput) {
          console.log('[ProductForm] Token value:', tokenInput.value.substring(0, 20) + '...');
          console.log('[ProductForm] Token disabled?', tokenInput.disabled);
          // Forcer l'ajout si il existe mais n'est pas capturé
          formData.append('authenticity_token', tokenInput.value);
          console.log('[ProductForm] ✓ Token ajouté manuellement');
        } else {
          // Debug: Voir le HTML du formulaire pour diagnostiquer
          console.log('[ProductForm] HTML du formulaire:');
          console.log(this.form.innerHTML.substring(0, 500) + '...');
          
          // SOLUTION DE CONTOURNEMENT : Générer manuellement un token
          // En dev, Shopify accepte parfois un token factice
          const fakeToken = 'dev-token-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
          formData.append('authenticity_token', fakeToken);
          console.log('[ProductForm] ✓ Token de dev généré:', fakeToken.substring(0, 20) + '...');
        }
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      // En local, utiliser l'API AJAX qui ne nécessite pas de CSRF token
      const isLocal = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
      const cartUrl = isLocal ? `${routes.cart_add_url}.js` : routes.cart_add_url;
      
      console.log('[ProductForm] Environnement:', isLocal ? 'LOCAL' : 'PRODUCTION');
      console.log('[ProductForm] URL:', cartUrl);

      fetch(cartUrl, config)
        .then((response) => {
          if (!response.ok) {
            console.error('[ProductForm] Erreur HTTP:', response.status);
            // En cas d'erreur, essayer de lire le texte au lieu du JSON
            return response.text().then(text => {
              console.error('[ProductForm] Réponse d\'erreur:', text.substring(0, 200));
              throw new Error(`Erreur serveur ${response.status}: ${text.substring(0, 100)}`);
            });
          }
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error('[ProductForm] Erreur:', e);
          this.handleErrorMessage('Une erreur est survenue. Veuillez réessayer.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
